import { getMailingAddressFormProps, MailingAddressFormProps } from '@App/forms/common/mailing-address-form'
import { FormDiscriminatedProps } from '@App/forms/common/form-field'
import { OPTIONAL_LAST_NAME, STANDARD_EMAIL, STANDARD_FIRST_NAME } from '@App/forms/common/generic-form-field-props'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { contactTypeOptions } from '@Const/options/dropdown-options'
import { DropdownDiscriminatedProps } from '@App/forms/common/dropdown-form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { createPhoneNumberFormFields, PhoneNumberFormProps } from '@App/forms/common/phone-number-form'

export interface RightsholderContactFormFields {
    firstName: FormDiscriminatedProps
    lastName: FormDiscriminatedProps
    email: FormDiscriminatedProps
    rightsholderContactTypeId: DropdownDiscriminatedProps
    address: MailingAddressFormProps
    phoneNumber: PhoneNumberFormProps
}

export const createRightsholderContactFormFields = (): RightsholderContactFormFields => ({
    firstName: STANDARD_FIRST_NAME,
    lastName: OPTIONAL_LAST_NAME,
    email: STANDARD_EMAIL,
    rightsholderContactTypeId: {
        name: 'rightsholderContactTypeId',
        label: 'Contact Type',
        type: FormFieldTypes.DROPDOWN,
        options: contactTypeOptions,
        registerOptions: {
            required: REQUIRED_MESSAGE,
        },
    },
    address: getMailingAddressFormProps('address.', true, true),
    phoneNumber: createPhoneNumberFormFields('phoneNumber.', true),
})
